import { STATICS } from 'statics'
import './style.scss'

export function AICard({ title, message, children, onCtaClick, ctaLabel = '', ctaUrl = '', icon }) {
  function renderCtaContent() {
    return (
      <>
        {ctaLabel} <STATICS.ARROW_NEXT />
      </>
    )
  }

  function renderCtaUrl() {
    return (
      <a href={ctaUrl} target='_blank' rel='noopener noreferrer' className='cta-button'>
        {renderCtaContent()}
      </a>
    )
  }

  function renderCta() {
    if ((!onCtaClick && !ctaUrl) || !ctaLabel) return null

    if (ctaUrl) return renderCtaUrl()

    return (
      <button type='button' className='cta-button' onClick={onCtaClick}>
        {renderCtaContent()}
      </button>
    )
  }

  function renderDynamicContent() {
    if (!children) return null

    return <div className='ai-card-content'>{children}</div>
  }

  function renderMessage() {
    return (
      <div className='message-container'>
        {icon ? <div className='message-icon'>{icon}</div> : null}
        <p className='message'>{message}</p>
      </div>
    )
  }

  return (
    <div className='ai-card-container'>
      <div className='title'>{title}</div>
      <div className='divider' />
      {renderMessage()}
      {renderDynamicContent()}
      {renderCta()}
    </div>
  )
}
